import React from 'react';
import { ParameterGroup as ParameterGroupType } from '../../types/app';
import { SliderInput } from './SliderInput';
import { getNestedValue } from '../../utils/formatters';
import { TooltipIcon } from '../Common/TooltipIcon';
import { PARAMETER_TOOLTIPS } from '../../utils/constants';

interface ParameterGroupProps {
  group: ParameterGroupType;
  parameters: any; // The full parameters object (CalculatorParams)
  onParameterChange: (key: string, value: any) => void;
  disabled?: boolean;
}

export const ParameterGroup: React.FC<ParameterGroupProps> = ({
  group,
  parameters,
  onParameterChange,
  disabled = false,
}) => {
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-4">
      <div className="flex items-center gap-2 mb-4">
        <h3 className="text-md font-semibold text-gray-900">
          {group.title}
        </h3>
      </div>

      <div className="space-y-4">
        {group.parameters.map((paramConfig) => {
          const current = getNestedValue(parameters, paramConfig.key);
          const currentValue = current !== undefined ? current : 0;
          const tooltipContent = PARAMETER_TOOLTIPS[paramConfig.key as keyof typeof PARAMETER_TOOLTIPS] || '';

          return (
            <div key={paramConfig.key} className="space-y-2">
              <div className="flex items-center gap-2">
                <label className="text-sm font-medium text-gray-700">
                  {paramConfig.label}
                </label>
                {tooltipContent && (
                  <TooltipIcon content={tooltipContent} />
                )}
              </div>
              <SliderInput
                config={paramConfig}
                value={currentValue}
                onChange={(value) => onParameterChange(paramConfig.key, value)}
                disabled={disabled}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
